import { Button } from "@admin/components/atoms/Button";
import { Modal, ModalProps } from "@admin/components/atoms/Modal";
import {
  deleteFoodControlPointInstance,
  FoodControlPointInstance,
} from "@enos-monorepo/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

interface DeleteInstanceModalProps extends ModalProps {
  selectedInstance: FoodControlPointInstance;
  callBack?: () => void;
}

export function DeleteInstanceModal({
  selectedInstance,
  callBack,
  ...props
}: DeleteInstanceModalProps) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => deleteFoodControlPointInstance(selectedInstance.id ?? ""),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["foodControlPoints"] });
      queryClient.invalidateQueries({
        queryKey: ["foodControlPointInstances"],
      });
      callBack?.();
      props?.onClose?.();
      toast.success("Control Successfully Deleted");
    },
    onError: (err: Error) => {
      toast.error("An error occured while deleting control");
    },
  });

  return (
    <Modal
      title={t("food.Delete Control")}
      {...props}
      actionButtons={
        <>
          <Button variant="secondary" type="button" onClick={props?.onClose}>
            {t("common.Discard")}
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={mutation.isPending}
            loading={mutation.isPending}
            onClick={() => mutation.mutate()}
          >
            {t("common.Delete")}
          </Button>
        </>
      }
    >
      <form>
        <div>{t("food.Delete Control Warning")}</div>
      </form>
    </Modal>
  );
}
